import { InjectionToken, ModuleWithProviders, NgModule } from '@angular/core';
import { Action, ActionReducer, StoreModule } from '@ngrx/store';
import { flightAvailabilityToCheckinReducer } from './flight-availability-to-checkin.reducer';
import {
  FLIGHT_AVAILABILITY_TO_CHECKIN_STORE_NAME,
  FlightAvailabilityToCheckinState,
} from './flight-availability-to-checkin.state';

/** Token of the FlightAvailabilityToCheckin reducer */
export const FLIGHT_AVAILABILITY_TO_CHECKIN_REDUCER_TOKEN = new InjectionToken<
  ActionReducer<FlightAvailabilityToCheckinState, Action>
>('Feature FlightAvailabilityToCheckin Reducer');

/** Provide default reducer for FlightAvailabilityToCheckin store */
export function getDefaultFlightAvailabilityToCheckinReducer() {
  return flightAvailabilityToCheckinReducer;
}

@NgModule({
  imports: [
    StoreModule.forFeature(FLIGHT_AVAILABILITY_TO_CHECKIN_STORE_NAME, FLIGHT_AVAILABILITY_TO_CHECKIN_REDUCER_TOKEN),
  ],
  providers: [
    { provide: FLIGHT_AVAILABILITY_TO_CHECKIN_REDUCER_TOKEN, useFactory: getDefaultFlightAvailabilityToCheckinReducer },
  ],
})
export class FlightAvailabilityToCheckinStoreModule {
  public static forRoot<T extends FlightAvailabilityToCheckinState>(
    reducerFactory: () => ActionReducer<T, Action>
  ): ModuleWithProviders<FlightAvailabilityToCheckinStoreModule> {
    return {
      ngModule: FlightAvailabilityToCheckinStoreModule,
      providers: [{ provide: FLIGHT_AVAILABILITY_TO_CHECKIN_REDUCER_TOKEN, useFactory: reducerFactory }],
    };
  }
}
